require('./bootstrap');

require('alpinejs');

import 'animate.css';

import './helper';
